import { render, staticRenderFns } from "./WombatRow.vue?vue&type=template&id=3c4c812a&scoped=true"
import script from "./WombatRow.vue?vue&type=script&lang=js"
export * from "./WombatRow.vue?vue&type=script&lang=js"
import style0 from "./WombatRow.vue?vue&type=style&index=0&id=3c4c812a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4c812a",
  null
  
)

export default component.exports